import { track } from "jiffy-analytics";

// eslint-disable-next-line import/prefer-default-export
export const initVideoTracking = (video, target) => {
  if (video) {
    video.addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement === video) {
        track("video_player_interaction", {
          target,
          action: "fullscreen_click"
        });
      }
    });

    let lastMuted = video.muted;
    video.addEventListener("volumechange", () => {
      video.muted = video.muted || video.volume === 0;

      if (lastMuted !== video.muted) {
        track("video_player_interaction", {
          target,
          action: video.muted ? "mute_click" : "unmute_click"
        });
      }

      lastMuted = video.muted;
    });
  }
};
